import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import ParagraphTag from "../../reusebale/Paragraph";

import BaseUrl from "../../../constants/BaseUrl"
import { useSelector } from "react-redux";
const TutorialSection = ({ onViewCreate, search }) => {
  const [isShowPopup, setShowPopup] = useState(false)
  const { loginSuccess } = useSelector((state) => state.auth);
  const [data, setData] = useState([

  ]);

  const handleOpen = () => {
    setShowPopup(true)
  }

  const handleClose = () => {
    setShowPopup(false)
  }

  const GetAllTutorials = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(`${BaseUrl}api/tutorials/getAllTutorialsByRole?page=1&limit=150&role=Tenant`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setData(result.data)
        }
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
    GetAllTutorials()
  }, [])

  return (
    <div className="h-full pt-4">
      <div className="bg-white w-full rounded-lg h-[87%]">
        <div className="w-[95%] mx-auto h-full">
          {/* <div className="flex justify-between items-center h-[12%]">
            <div className="w-full flex justify-end">
              <button
                className="w-[20%] bg-themeColor rounded-md flex items-center justify-center py-2"
                onClick={onViewCreate}
              >
                <Plus color="#FFFFFF" size={15} />
                <ParagraphTag
                  content="Create New"
                  classes="text-white font-popinsSemiBold text-xs pl-2"
                  onTrigger={handleOpen}
                />
              </button>
            </div>
          </div> */}
          <div className="overflow-x-scroll w-full h-full panelScroll pt-2 flex flex-wrap" id="gk-cards">
            {data?.map((item, i) => {
              if (item?.title?.toUpperCase()?.includes(search.toUpperCase())) {
                return (
                  <div className="w-[32%] mr-[2%] pt-3" key={i}>
                    <div className="overflow-hidden">
                      <iframe
                        className="w-full h-56 rounded-2xl shadow-lg"
                        src={
                          item?.link?.replace("watch?v=", "embed/").split("&")[0] +
                          "?rel=0&modestbranding=1"
                        }
                        title={item.title}
                        allowFullScreen
                      ></iframe>
                    </div>
                    <ParagraphTag
                      content={item?.title}
                      classes="text-dark font-popinsRegular text-md flex justify-center items-center my-2"
                    />
                  </div>
                )
              }
            })}
          </div>
        </div>
      </div>

    </div>
  );
};

export default TutorialSection;

